import { Dumbbell, Flame, Zap, Target, Heart, Trophy, Mountain, PersonStanding } from "lucide-react";

export const DEFAULT_PROGRAM_ICON = "dumbbell";

export const PROGRAM_ICON_MAP: Record<string, { icon: any; color: string }> = {
  dumbbell: { icon: Dumbbell, color: "from-orange-500 to-red-500" },
  flame: { icon: Flame, color: "from-red-500 to-pink-500" },
  zap: { icon: Zap, color: "from-yellow-500 to-orange-500" },
  target: { icon: Target, color: "from-blue-500 to-cyan-500" },
  heart: { icon: Heart, color: "from-pink-500 to-rose-500" },
  trophy: { icon: Trophy, color: "from-amber-500 to-yellow-500" },
  mountain: { icon: Mountain, color: "from-emerald-500 to-teal-500" },
  person: { icon: PersonStanding, color: "from-violet-500 to-purple-500" },
};

export const ICON_OPTIONS = Object.entries(PROGRAM_ICON_MAP).map(([id, config]) => ({
  id,
  icon: config.icon,
  color: config.color,
}));
